import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Edit } from 'lucide-react';
interface MessagesPanelProps {
  isOpen: boolean;
  onClose: () => void;
}
const mockMessages = [{
  id: '1',
  user: {
    name: 'Sarah Jenkins',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&q=80'
  },
  lastMessage: 'Love this design! Where did you find it?',
  time: '2m',
  unread: true
}, {
  id: '2',
  user: {
    name: 'Marcus Chen',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100&q=80'
  },
  lastMessage: 'Thanks for sharing!',
  time: '1h',
  unread: false
}, {
  id: '3',
  user: {
    name: 'Elena Rodriguez',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100&q=80'
  },
  lastMessage: 'Can you send me the link?',
  time: '3h',
  unread: false
}];
export function MessagesPanel({
  isOpen,
  onClose
}: MessagesPanelProps) {
  if (!isOpen) return null;
  return <>
      <div className="fixed inset-0 z-40" onClick={onClose} data-id="element-98" />
      <AnimatePresence data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} className="absolute right-0 top-full mt-2 w-80 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden z-50" onClick={e => e.stopPropagation()} data-id="element-100">
          <div className="p-4 border-b border-gray-100 flex items-center justify-between" data-id="element-101">
            <h3 className="font-bold text-gray-900" data-id="element-102">Messages</h3>
            <button className="p-1.5 hover:bg-gray-100 rounded-full transition-colors" data-id="element-103">
              <Edit className="w-4 h-4 text-gray-600" data-id="element-104" />
            </button>
          </div>

          <div className="max-h-96 overflow-y-auto" data-id="element-105">
            {mockMessages.map(msg => <button key={msg.id} className="w-full flex items-center gap-3 p-4 hover:bg-gray-50 transition-colors text-left border-b border-gray-50 last:border-0" data-id="element-106">
                <div className="relative" data-id="element-107">
                  <img src={msg.user.avatar} alt={msg.user.name} className="w-12 h-12 rounded-full object-cover" data-id="element-108" />
                  {msg.unread && <div className="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full border-2 border-white" data-id="element-109" />}
                </div>
                <div className="flex-1 min-w-0" data-id="element-110">
                  <div className="flex items-center justify-between gap-2" data-id="element-111">
                    <p className={`text-sm truncate ${msg.unread ? 'font-bold text-gray-900' : 'font-medium text-gray-700'}`} data-id="element-112">
                      {msg.user.name}
                    </p>
                    <span className="text-xs text-gray-400 shrink-0" data-id="element-113">
                      {msg.time}
                    </span>
                  </div>
                  <p className={`text-sm truncate mt-0.5 ${msg.unread ? 'text-gray-900' : 'text-gray-500'}`} data-id="element-114">
                    {msg.lastMessage}
                  </p>
                </div>
              </button>)}
          </div>

          <div className="p-3 border-t border-gray-100" data-id="element-115">
            <button className="w-full py-2 text-sm font-semibold text-gray-600 hover:text-black transition-colors" data-id="element-116">
              See all messages
            </button>
          </div>
        </motion.div>
      </AnimatePresence>
    </>;
}